/**
 * Radio supported colors.
 */
export const COLORS = {
    GREY: 'grey',
    GREEN: 'green'
} as const;
